module.exports = __webpack_public_path__ + "img/Breisgau.6cde2632.jpg";